import { JSX, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../store/AppStore';
import { setAuthState } from '../store/states/UserSlice';

/**
 * Renders the  error screen for unauthenticated user login
 * @returns {JSX.Element} the unauthenticated  component
 */
export const Unauthenticated = (): JSX.Element | null => {
  const dispatch = useDispatch<AppDispatch>();

  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState(false);
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout>>();
  const authState = useSelector((state: AppState) => state.user.authState);

  useEffect(() => {
    if (authState !== 'logout') {
      if (showMessage) {
        setShowMessage(false);
      }
      setTimer(setTimeout(() => setShowMessage(true), 5000));
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
      dispatch(setAuthState('initial'));
    };
  }, [authState, timer, dispatch, showMessage]);

  return (showMessage && <h4>{t('messages.unauthenticated')}</h4>) || null;
};
